import { useAuth } from '@/context/AuthContext';
import useLimits from '@/hooks/useLimits';
import { motion } from 'motion/react';
import { Button } from '../Button/Button';
import { useUpgrade } from '../Modals/UpgradeModal';
import Tag from '../Tag';
import ProgressBar from './PlanUsageProgressBar';

const PlanUsage = () => {
  const { userPlanDetails } = useAuth();
  const { showUpgrade } = useUpgrade();

  const { limits, usage } = useLimits();

  if (!limits || !usage) return null;

  return (
    <motion.div className="flex flex-col items-left w-full gap-2 p-2.5 border bg-popover rounded-[10px] ">
      <div className="flex flex-row gap-1.5 items-center">
        <h2 className="text-xs leading-5 font-medium text-foreground/75">
          Plan usage
        </h2>
        <Tag label={userPlanDetails?.planName} color="blue" size="lg" />
      </div>

      {limits.wordLimit && (
        <ProgressBar
          maxCount={limits.wordLimit ?? 0}
          count={usage.wordCount}
          label="AI words/day"
          tooltipLabel="Any word generated by an AI feature"
          tooltipId="wordsTooltip"
        />
      )}
      {limits.legacyImportLimit && (
        <ProgressBar
          maxCount={limits.legacyImportLimit ?? 0}
          count={usage.legacyImportCount}
          label="Imports/day"
          tooltipLabel="An import is any time you import a website or document"
          tooltipId="importsTooltip"
        />
      )}
      {limits.recordingLimit && (
        <ProgressBar
          maxCount={limits.recordingLimit ?? 0}
          count={usage.recordingCount}
          label="Recordings/day"
          tooltipLabel="Any time you start a new recording"
          tooltipId="recordingTooltip"
        />
      )}

      <Button
        variant="default"
        className="w-full tracking-normal font-medium leading-5 mt-1 rounded-md"
        size="xs"
        onClick={() => showUpgrade('generic')}
      >
        Get unlimited
      </Button>
    </motion.div>
  );
};

export default PlanUsage;
